import { useAuth } from "oidc-react";

export function useUserClaims() {
  const { userData } = useAuth();
  return {
    firstName:
      userData?.profile?.[
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname"
      ] ?? "",
    lastName:
      userData?.profile?.[
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname"
      ] ?? "",
    companyName:
      userData?.profile?.[
        "http://credentials.hcssapps.com/schemas/2015/09/identity/claims/companyname"
      ] ?? "",
  };
}
